import Vue from 'vue';
import Message from 'primevue/message';

Vue.component('Message', Message);
